import { render, staticRenderFns } from "./collaborativeWaiting.vue?vue&type=template&id=422348f4&scoped=true"
import script from "./collaborativeWaiting.vue?vue&type=script&lang=js"
export * from "./collaborativeWaiting.vue?vue&type=script&lang=js"
import style0 from "./collaborativeWaiting.vue?vue&type=style&index=0&id=422348f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422348f4",
  null
  
)

export default component.exports